// Tauri桥接工具：在Tauri环境中调用后端启动命令；在Web环境中安全降级
// 说明：
// - 直接静态导入 v1 API 的 invoke；若运行在浏览器环境，库会抛出明确错误
// - 提供 isTauriAvailable 与 startBackends 两个入口

import { invoke } from '@tauri-apps/api/tauri';

export async function isTauriAvailable(): Promise<boolean> {
  try {
    // 优先根据协议判断（打包后为 tauri://、app:// 或 file://）
    const proto = (typeof window !== 'undefined' && window.location && window.location.protocol) ? window.location.protocol : '';
    if (proto.startsWith('tauri') || proto.startsWith('app') || proto.startsWith('file')) return true;
    // 回退：检测全局 __TAURI__ 对象，兼容 v1/v2
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const g: any = (window as any).__TAURI__;
    return !!(g && (typeof g.invoke === 'function' || typeof g?.tauri?.invoke === 'function'));
  } catch {
    return false;
  }
}

export async function startBackends(tushareToken?: string): Promise<{ ok: boolean; message: string }>{
  try {
    // 在非Tauri环境下直接返回友好提示，避免 window.__TAURI_IPC__ 错误
    const available = await isTauriAvailable();
    if (!available) {
      return { ok: false, message: '桌面接口不可用：当前为浏览器环境，已跳过后端自动启动。请手动运行后端或使用打包版桌面应用。' };
    }
    // 直接使用 tauri v1 的 invoke 调用桌面命令
    const msg = await invoke('start_backends', { tushareToken });
    return { ok: true, message: (msg as string) || '后端服务已启动' };
  } catch (e: any) {
    const m = String(e?.message || '');
    if (m.includes('tauri') && m.includes('environment')) {
      return { ok: false, message: '桌面接口不可用：未检测到 Tauri 环境。请手动启动后端或检查应用打包。' };
    }
    return { ok: false, message: m || '启动后端失败（前端调用异常）' };
  }
}